import styled from 'styled-components';

import { getColor, getShadow } from '@process-advisor/process-miner/shared/theme';

export const CustomPointer = styled.div`
    cursor: pointer;
    width: 4px;
    border-radius: 1px;
    height: 8px;
    box-shadow: ${getShadow('slider')};
    background: ${getColor('white')};
    transform: translate(-2px, 1px);
`;
